module.exports = __webpack_public_path__ + "static/media/certn.08852684.jpeg";